var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 6H21C22.6569 6 24 7.34315 24 9V19C24 20.6569 22.6569 22 21 22H7C5.34315 22 4 20.6569 4 19V9C4 7.34315 5.34315 6 7 6ZM6.69123 8.04858L13.386 13.2556C13.7471 13.5365 14.2528 13.5365 14.6139 13.2556L21.3087 8.04855C21.2115 8.01703 21.1077 8 21 8H7C6.89225 8 6.78847 8.01704 6.69123 8.04858ZM22 10.0446L15.8417 14.8343C14.7584 15.6769 13.2414 15.6769 12.1581 14.8343L6 10.0447V19C6 19.5523 6.44772 20 7 20H21C21.5523 20 22 19.5523 22 19V10.0446Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.d66f523339c8053b466c95b30b443afc.svg";
export { ForwardRef as ReactComponent };